import { Tabs, Tab, Paper, Select, MenuItem, FormControl, useMediaQuery } from "@mui/material"

const LABELS = ['Reserve Rates', 'Invoice Configuration', 'Opening Balance'];

const CustomTab = ({ value, onChange }) => {
    const isMobile = useMediaQuery('(max-width: 600px)');
    const isTabletPortrait = useMediaQuery('(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)');
    const showDropdown = isMobile || isTabletPortrait;

    const handleSelectChange = (e) => {
        onChange(e, Number(e.target.value));
    };

    return (
        <>
            {showDropdown ? (
                <FormControl size="small" className="rental-mob-dropdown">
                    <Select value={value} onChange={handleSelectChange} className="mob-dropdown">
                        {LABELS.map((label, i) => (
                            <MenuItem key={i} value={i}>{label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            ) : (
                <Paper className="reserve-tabs-paper">
                    <Tabs className="reserve-rate-invoice-tab" value={value} onChange={onChange}>
                        {LABELS.map((label, i) => (
                            <Tab key={i} className="ile-name" label={label} />
                        ))}
                    </Tabs>
                </Paper>
            )}
        </>
    );
};

export default CustomTab;
